import _, { filter as _filter } from 'lodash';
import { find as _find } from 'lodash';

class BaseReportController {
  constructor(reportingService, loadingService, utilsService) {    
    this.reportingService = reportingService;
    this.loadingService = loadingService;
    this.utilsService = utilsService;
  }

  updateDateRange() {
    this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
    const src = this.reportingService.getDateRange(this.reportCriteria.dateRangeOption.id);

    src
      .then((response) => {          
        this.reportCriteria.startDate = response.data.startDate ? new Date(response.data.startDate) : null;
        this.reportCriteria.endDate = response.data.endDate ? new Date(response.data.endDate) : null;
      })
      .finally(() => {
        this.loadingService.hideLoading('reportCriteria');
      });

    return src;
  }

  parseStartAndEndDate(parsedCriteria) {
      if (this.reportCriteria.startDate) {
        parsedCriteria.startDate = this.reportCriteria.startDate.toUniversalFormat();
      }

      if (this.reportCriteria.endDate) {
        parsedCriteria.endDate = this.reportCriteria.endDate.toUniversalFormat();
      }
  }

  getUserLocations() {
    const locationsWithRoles = this.authService.authData.userLocations.map(l => {      
        return {
          id: l.key, 
          name: l.value,
          roleId: _find(this.authService.authData.userRoles, o => o.entityId === l.key).roleId,
          isDefault: l.defaultLocation
        };
    });

    this.userLocations = _(locationsWithRoles)
              .filter(o => o.roleId !== 2 || o.isDefault)
              .map(o => ({id: o.id, name: o.name}))
              .value();

    this.userLocations.unshift({id: null, name: 'All'})
  }
}

export default BaseReportController;



// WEBPACK FOOTER //
// ./client/app/components/reports/baseReportController.js